export default __webpack_public_path__ + "locales/si/EmptyView.json?hash=a7d71a00d28e221f901efd983684efb8";